import { browser } from '$app/environment';

import { derived, writable } from 'svelte/store';
import type { Writable, Readable } from 'svelte/store';

type StoresAndKeys = {
  stores: Writable<any>[];
  keys: string[];
};

type CookieStore = {
  [key: string]: Writable<any>;
};

export const COOKIE_COLLECTION_NAME = 'do-stored-data';

const storesToCombine: StoresAndKeys = {
  stores: [],
  keys: [],
};

const combinedStoredStore: Readable<any> = derived(storesToCombine.stores, (data: Writable<any>[]) => {
  if (browser) {
    const cookieStore: CookieStore = {};
    data.forEach((item: Writable<any>, index: number) => {
      cookieStore[storesToCombine.keys[index]] = item;
    });
    document.cookie = `${COOKIE_COLLECTION_NAME}=${JSON.stringify(cookieStore)}`;
  }
  return data;
});

export const createStorableWritable = (key: string, initialValue: any): Writable<any> => {
  const storableWritable: Writable<any> = writable(initialValue);
  storesToCombine.stores.push(storableWritable);
  storesToCombine.keys.push(key);
  return storableWritable;
};

export const setCombinedStoresInitData = (cookieData: string | undefined): void => {
  // eslint-disable-next-line
  combinedStoredStore.subscribe(() => {});
  if (typeof cookieData === 'undefined' || cookieData === null || !storesToCombine.stores.length) return;

  const parsedCookieData = JSON.parse(cookieData);
  storesToCombine.stores.forEach((item: Writable<any>, index: number) => {
    // eslint-disable-next-line
    if (parsedCookieData.hasOwnProperty(storesToCombine.keys[index])) {
      item.set(parsedCookieData[storesToCombine.keys[index]]);
    }
  });
};
